import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { FeatureFlagControl } from "@/Common/Components/FeatureFlagControl";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { CheckedListControl } from "@/Common/Components/Inputs/CheckedListControl";
import { CheckedListControl2 } from "@/Common/Components/Inputs/CheckedListControl2";
import { MultiDateSelector } from "@/Common/Components/Inputs/MultiDateSelector";
import { SearchSettingsFooter } from "@/Common/Components/Settings/SearchSettingsFooter";
import { EmployeeTitleHelper } from "@/Common/Helpers/EmployeeTitleHelper";
import { SearchMenuHelper } from "@/Common/Helpers/SearchMenuHelper";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { LabInboxes } from "@/Common/Models/UI/Enums";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { CliniciansCheckBoxControl } from "@/Labs/Components/Inputs/CliniciansCheckBoxControl";
import { ILabsInboxModel } from "@/Labs/Models/UI/ILabsInboxModel";
import { LabsInboxSettingsContainerProcessingStatusSection } from "./LabsInboxSettingsContainerProcessingStatusSection";

import "./LabsInboxSettingsContainer.css";
import styles from "./LabsInboxSettingsContainer.module.scss";

interface ILabsInboxSettingsContainerProps {
    LabViewModel: ILabsInboxModel;
}

class LabsInboxSettingsContaineState { }

class LabsInboxSettingsContainer extends BaseReactComponent<ILabsInboxSettingsContainerProps, LabsInboxSettingsContaineState> {
    public componentDidMount(): void {
        super.setOverlay("LabsInboxSettingsContainer", { transparent: true });
    }

    public render(): JSX.Element {
        const str = this.props.LabViewModel.get("CliniciansSearchText").trim();
        const strSentBy = this.props.LabViewModel.get("SentBySearchText").trim();
        const cliniciansToRender = this.FilterText(str, this.props.LabViewModel.get("CliniciansGlobalCache")).filterImmutable(x => x.ContactFacetId != sessionStore.getCurrentEmployee().ContactFacetId);
        const cliniciansToRenderself = this.FilterText(str, this.props.LabViewModel.get("CliniciansGlobalCache")).filterImmutable(x => x.ContactFacetId == sessionStore.getCurrentEmployee().ContactFacetId);
        const sentByToRender = this.FilterText(strSentBy, this.props.LabViewModel.get("SentByGlobalCache"));
        const isFromPatient = this.props.LabViewModel.get("IsFromPatient");
        const hasPortalAccess = cacheStore.ClinicSettings_Portal.EnablePortalWebsite && isFromPatient;

        return (
            <div className="labinbox-settings">
                <div>
                    <table className="f-content">
                        <thead>
                            <tr>
                                <th className="first" style={{ width: "240px" }}>
                                    <label style={{ display: "inline" }}>{cacheStore.GetString("MessageDateLabel").toUpperCase()}</label>
                                </th>
                                {this.props.LabViewModel.get("Sites").count() > 1 && (
                                    <th style={{ width: "160px" }}>
                                        <CheckboxControl
                                            id="sites_check"
                                            label={cacheStore.GetString("SitesLabel").toUpperCase()}
                                            operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                            checked={this.props.LabViewModel.get("SelectAllSitesChecked")}
                                            target={CheckboxTarget.Myle_Labs_SitesControlCheck}
                                        />
                                    </th>
                                )}

                                <th className="first">
                                    <CliniciansCheckBoxControl
                                        targetClinicians={CheckboxTarget.Myle_Labs_AllCliniciansPrescriptorControlCheck}
                                        targetDeactivatedClinicians={CheckboxTarget.Myle_Labs_ShowDeactivatedClinicians}
                                        checkedClinicians={this.props.LabViewModel.get("SelectAllCliniciansChecked")}
                                        checkedDeactivatedClinicians={this.props.LabViewModel.get("ShowDeactivatedClinicians")}
                                        operationClinicianCheckedChange={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                        operationClinicianDeactivatedChange={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                    />
                                </th>
                                <th className="last">
                                    {cacheStore.GetString("SettingsLabel").toUpperCase()}
                                </th>
                                {hasPortalAccess && (
                                    <th>
                                        <CheckboxControl
                                            id="sentBy_check"
                                            label={cacheStore.GetString("SentByLabel").toUpperCase()}
                                            operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                            target={CheckboxTarget.Myle_Documents_SentByControlCheck}
                                            checked={this.props.LabViewModel.get("SelectAllPortalSentBy")}
                                        />
                                    </th>
                                )}

                                {hasPortalAccess && (
                                    <th className="last">
                                        <CheckboxControl
                                            id="statusportal_check"
                                            label={cacheStore.GetString("StatusPortal").toUpperCase()}
                                            operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                            target={CheckboxTarget.Myle_Documents_PortalStatusControlCheck}
                                            checked={this.props.LabViewModel.get("SelectAllPortalStatus")}
                                            idModifier="sentby"
                                        />
                                    </th>
                                )}

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="first">
                                    <MultiDateSelector
                                        id="doc_search_date_selector"
                                        fromMyleOperation={LocalOperations.Labs.LabInboxSearchSettings_FromDateChanged}
                                        toMyleOperation={LocalOperations.Labs.LabInboxSearchSettings_ToDateChanged}
                                        fromSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                        toSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                        from={this.props.LabViewModel.get("DateFrom")}
                                        to={this.props.LabViewModel.get("DateTo")}
                                    />

                                </td>

                                {this.props.LabViewModel.get("Sites").count() > 1 && (
                                    <td className="sites-column">
                                        <div style={{ maxHeight: "400px", minHeight: "400px", overflow: "auto" }}>
                                            <CheckedListControl
                                                DataSource={this.props.LabViewModel.get("Sites")}
                                                Operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                                MaxTextLength={25}
                                            />
                                        </div>
                                    </td>
                                )}
                                <td style={{ width: "227px" }} className="first">
                                    <input className="form-control" style={{ width: "225px" }} type="text" value={this.props.LabViewModel.get("CliniciansSearchText")} onChange={e => this.onClinitiansFilterTextChanged(e)} placeholder={cacheStore.GetString("SearchLabel").toUpperCase()} />
                                    {cliniciansToRenderself != null && cliniciansToRenderself.count() > 0 && (
                                        <div>
                                            <CheckedListControl2
                                                DataSource={cliniciansToRenderself}
                                                Operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                                sort
                                                limitTextWidth
                                            />
                                        </div>
                                    )}

                                    <div style={{ maxHeight: "400px", minHeight: "400px", overflow: "auto", marginTop: "15px" }}>
                                        <CheckedListControl2
                                            DataSource={cliniciansToRender}
                                            Operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                            sort
                                            limitTextWidth
                                        />
                                    </div>
                                </td>
                                <td className="last">
                                    <FeatureFlagControl
                                        flag={cacheStore.ClinicSettings.EnableLabResultProcessingStatus}
                                        fallbackFeature={null}
                                        activeFeature={(
                                            <>
                                                <LabsInboxSettingsContainerProcessingStatusSection LabViewModel={this.props.LabViewModel} />
                                                <h5>{cacheStore.GetString("OtherFiltersLabel")}</h5>
                                            </>
                                        )
                                        }
                                    />

                                    <div className={styles.checkboxContainer}>
                                        <CheckboxControl
                                            id="ShowAbnormalsOnly"
                                            checked={this.props.LabViewModel.get("ShowAbnormalsOnly")}
                                            label={cacheStore.GetString("AbnormalOnly")}
                                            operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                            target={CheckboxTarget.Myle_Labs_ShowAbnormalOnlysSelected}
                                            DivWrap
                                        />
                                        <FeatureFlagControl
                                            flag={cacheStore.ClinicSettings.EnableLabResultProcessingStatus}
                                            activeFeature={<p className={styles.checkboxDescription}> {cacheStore.GetString("OnlyShowAbnormalResultsCheckboxComment")}</p>}
                                            fallbackFeature={null}
                                        />
                                    </div>
                                    {cacheStore.ClinicSettings.EnableEnrolledPatientResultFilter
                                        && EmployeeTitleHelper.isDoctor(sessionStore.getCurrentEmployee().getIssuingOrgRule()?.Title)
                                        && (
                                            <CheckboxControl
                                                id="ShowEnrolledPatientsResults"
                                                checked={this.props.LabViewModel.get("ShowEnrolledPatientsResults")}
                                                label={this.getString("ShowEnrolledPatientsResultsLabel")}
                                                operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                                target={CheckboxTarget.Myle_Labs_ShowEnrolledPatientsResults}
                                                DivWrap
                                            />
                                        )
                                    }
                                    {this.props.LabViewModel.get("CurrentInbox") != LabInboxes.ManualResults && (
                                        <FeatureFlagControl
                                            flag={cacheStore.ClinicSettings.EnableLabResultProcessingStatus}
                                            fallbackFeature={null}
                                            activeFeature={(
                                                <div className={styles.checkboxContainer}>
                                                    <CheckboxControl
                                                        id="AlwaysShowAbnormalResults"
                                                        checked={this.props.LabViewModel.get("AlwaysShowAbnormalResults")}
                                                        label={cacheStore.GetString("AlwaysShowAbnormalResultsCheckboxLabel")}
                                                        operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                                        target={CheckboxTarget.Myle_Labs_AlwaysShowAbnormalResults}
                                                    />
                                                    <p className={styles.checkboxDescription}> {cacheStore.GetString("AlwaysShowAbnormalResultsCheckboxComment")}</p>
                                                </div>
                                            )}
                                        />
                                    )}
                                    {this.props.LabViewModel.get("CurrentInbox") === LabInboxes.New && cacheStore.ClinicSettings.EnableResultsFixes && (
                                        <CheckboxControl
                                            id="HideResultsFiledByColleague"
                                            checked={this.props.LabViewModel.get("HideResultsFiledByColleague")}
                                            label={cacheStore.GetString("HideResultsFiledByColleagueLabel")}
                                            operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                            target={CheckboxTarget.Myle_Labs_HideResultsFiledByColleague}
                                            DivWrap
                                        />
                                    )}
                                </td>

                                {hasPortalAccess && (
                                    <td style={{ width: "227px" }}>
                                        <input className="rounded status-search-box" type="text" value={this.props.LabViewModel.get("SentBySearchText")} onChange={e => this.onSentByFilterTextChanged(e)} placeholder={cacheStore.GetString("SearchLabel").toUpperCase()} />
                                        <div style={{ maxHeight: "400px", minHeight: "400px", overflow: "auto" }}>
                                            <CheckedListControl
                                                DataSource={sentByToRender}
                                                Operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                                sort
                                                limitTextWidth
                                                idModifier="sentBy"
                                            />
                                        </div>
                                    </td>
                                )}

                                {hasPortalAccess && (
                                    <td className="last">
                                        <CheckedListControl
                                            DataSource={this.props.LabViewModel.get("PortalStatuses")}
                                            resolveValueInStringChange
                                            Operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                                            limitTextWidth
                                            idModifier="portalStatus"
                                        />
                                    </td>
                                )}
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <SearchSettingsFooter
                        onClose={() => sessionStore.dispatch(LocalOperations.Labs.LabInboxSearchSettings_OnCancelClick)}
                        onOk={() => sessionStore.dispatch(LocalOperations.Labs.LabInboxSearchSettings_OnOkClick)}
                        onColumnOrderingButtonClick={() => sessionStore.dispatch(LocalOperations.Labs.LabInboxColumnOrderingPopup_Open)}
                        onResultsPerPageChange={value => sessionStore.dispatch(LocalOperations.Labs.LabInboxSearchSettings_OnResultsPerPageChange, { value })}
                        selectedPageSizeOption={this.props.LabViewModel.get("SelectedPageSizeOption")}
                        pageSizeOptions={this.props.LabViewModel.get("PageSizeOptions").toArray()}
                        isSaveSettingsChecked={this.props.LabViewModel.get("SaveSettingsSelected")}
                        onSaveSettingsCheckboxChange={isFromPatient ? null : checked => this.saveFilterSettings(checked)}
                    />
                </div>
            </div>
        );
    }

    public onClinitiansFilterTextChanged(event: React.ChangeEvent<HTMLInputElement>): void {
        sessionStore.dispatch(LocalOperations.Labs.LabInboxSearchSettings_ClinicianFilterTextChanged, { value: event.target.value });
    }

    public onSentByFilterTextChanged(event: React.ChangeEvent<HTMLInputElement>): void {
        sessionStore.dispatch(LocalOperations.Labs.LabInboxSearchSettings_SentByTextChanged, { value: event.target.value });
    }

    private FilterText(str: string, fullList: Immutable.List<EmployeeUIModel>): Immutable.List<EmployeeUIModel> {
        return str !== ""
            ? SearchMenuHelper.FilterCliniciansByName(str, fullList)
            : fullList;
    }

    private saveFilterSettings(checked: boolean): void {
        sessionStore.dispatch(
            LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange,
            {
                target: CheckboxTarget.Myle_Labs_SaveSettingsSelected,
                checked: checked
            }
        );
    }
}

export { LabsInboxSettingsContainer };
